<template>
  <Card title="考核评价">
    <div style="padding-top: 16px"></div>
    <a-form
      style="width: 50%;margin: auto"
      :form="form"
      @submit="handleSubmit"
      :label-col="{ span: 4 }"
      :wrapper-col="{ span: 16 }"
      :colon="false"
    >
      <a-row>
        <a-col :lg="24" :md="24" :sm="24">
              <TextareaField :value="text.name" disabled labelWidth="10%" style="margin: 0.5rem 0.2rem" label="计划名称"/>
        </a-col>
        <a-col :lg="24" :md="24" :sm="24">
            <RangePickerField labelWidth="10%" label="考核时间" v-model="text.time" disabled :placeholder="['开始时间', '结束时间']"/>
        </a-col>
        <a-col :lg="24" :md="24" :sm="24">
            <TextareaField :value="text.remark" disabled labelWidth="10%" style="margin: 0.5rem 0.2rem" label="备注"/>
        </a-col>

        <a-col :lg="24" :md="24" :sm="24">
            <Assess :list="userList" @change="onAssessChange" />
        </a-col>
      </a-row>

      <div class="center">
        <a-space>
            <ButtonField text="关闭" @click="cancel" secondary />
            <ButtonField text="保存" primary @click="handleSubmit"/>
        </a-space>
      </div>
    </a-form>
  </Card>
</template>

<script>
import Assess from "./components/Assess";
import { assess } from "@/api/personnel-assess";
import moment from "moment";

export default {
  components: {
    Assess,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      userList: [],
      text: {},
      saveLoading: false,
    };
  },

  mounted() {
    const text = this.$route.query;
    if (!text.id) {
      return;
    }

    this.userList = text.userList.map((item, index) => {
      let completeRatio;
      if (item.taskNumPlan === 0) {
        completeRatio = "0%";
      } else {
        completeRatio =
          parseInt((item.taskNumDone / item.taskNumPlan) * 100) + "%";
      }

      return {
        ...item,
        key: index + 1,
        completeRatio,
      };
    });

    this.text = {
      ...text,
      time: [moment(text.timeBegin), moment(text.timeEnd)],
    };
  },

  methods: {
    cancel() {
      this.$router.go(-1);
    },
    onAssessChange(val) {
      this.userList = val;
      console.log(this.userList);
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let timeBegin, timeEnd;
          if (Array.isArray(values.time) && values.time.length === 2) {
            timeBegin = values.time[0].format("YYYY-MM-DD");
            timeEnd = values.time[1].format("YYYY-MM-DD");
          }

          this.saveLoading = true;
          assess({
            id: this.text.id,
            ...values,
            timeBegin,
            timeEnd,
            time: undefined,

            userList: this.userList.map((item) => {
              return {
                ...item,
                completeRatio: undefined,
              };
            }),
          })
            .then(() => {
              this.$router.go(-1);
            })
            .finally(() => {
              this.saveLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.center {
  padding-bottom: 24px;
}
</style>
